/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Image_Subtitles_AriaInputs */



/**
* | output |
* | --- |
* | "Export image-based subtitles" |
*
* @param {File_Export_Image_Subtitles_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_image_subtitles_aria = /** @type {((inputs?: File_Export_Image_Subtitles_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Image_Subtitles_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter des sous-titres en images")
	if (locale === "de") return /** @type {LocalizedString} */ ("Exportieren von bildbasierten Untertiteln")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta sottotitoli basati su immagini")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт субтитров на основе изображений")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar subtítulos basados en imágenes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出基于图像的字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("画像ベースの字幕をエクスポートする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("छवि-आधारित उपशीर्षक निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar legendas baseadas em imagens")
	return /** @type {LocalizedString} */ ("Export image-based subtitles")
});